// export const ZKSAFE_API_HOST = 'http://localhost:3003/dev/'
export const ZKSAFE_API_HOST = 'https://api.zksafe.pro/'

export const zksafeApi = {
    getChainInfo: `${ZKSAFE_API_HOST}chain/info`,
    getTokensBalance: `${ZKSAFE_API_HOST}tokens/balances`,
    getTokensMetadata: `${ZKSAFE_API_HOST}tokens/metadata`,
    getNftsForOwner: `${ZKSAFE_API_HOST}tokens/nfts`,
}